import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
import { toast, ToastContainer } from 'react-toastify';
import { Grid, Button, Stack, TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import dayjs from 'dayjs';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

const NewStudent = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
  const [courses, setCourses] = useState([]);
  const [profileFile, setProfileFile] = useState(null);
  const [nricFile, setNricFile] = useState(null);
  const [educationFile, setEducationFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [intake, setIntake] = useState([]);

  const [initialModulus, setInitialModulus] = useState(1)
  const [selectedBatch, setSelectedBatch] = useState(null)
  const [editFormData, setEditFormData] = useState({}); // Initialize form state
  const genderOptions = ["Male", "Female", "Other"];
  const statusOptions = ['Single', 'Married', 'Widowed', 'Divorced'];
  const [openDialog, setOpenDialog] = useState(false);
  const [alumniRegistrationId, setAlumniRegistrationId] = useState(null);
  const [allowAlumniRegistration, setAllowAlumniRegistration] = useState(null);
  const [pendingAlumniNric, setPendingAlumniNric] = useState("");
  const [warnings, setWarnings] = useState({});
  const moduleCount = selectedBatch?.moduleDetails?.length || 0;
  const [intakeOptions, setIntakeOptions] = useState([]);
  const [intakeIdsss, setIntakeIdsss] = useState('');
  const newScheduleDate = Array.from({ length: moduleCount }, () => ({
    startModulus: '',
    startDate: '',
    endDate: '',
  }));

  const [studentData, setStudentData] = useState({
    name: '',
    nric: '',
    email: '',
    phone: '',
    gender: '',
    dob: '',

    officephone: '',
    address: '',
    course: '',
    enrollmentDate: '',
    citizenship: '',
    signDate: '',
    race: '',
    education: '',
    employmentstatus: '',
    salary: '',
    companyname: '',

    designation: '',
    profileUrl: '',
    batchId: null,
    startModulus: null,
    status: false,
    passport: '',
    passportExpiryDate: '',
    fatherName: '',
    brotherName: '',
    fatherPhoneNo: '',
    brotherPhoneNo: '',
    religion: '',
    currentAddress: '',
    institutionDetails: [],
    emergencyContacts: [],
    workExpirences: [],
    projectSchedule: {
      projectCode: '',
      startDate: '',
      endDate: '',
    },
    nricdoc: '',
    educationdoc: '',
    passportdoc: '',
    scheduleDate: [],
    postalcode: '',
    // studentIds: '',
    completeDate: '',
    commencementDate: '',
    preIntake: '',
    maritalStatus: ''


  });
  const styles = {
    formContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    columnsContainer: {
      display: 'flex',
      gap: '24px',
      marginBottom: '24px',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
      },
    },
    column: {
      flex: 1,
      minWidth: 0,
    },
    section: {
      marginBottom: '24px',
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    sectionTitle: {
      marginTop: 0,
      marginBottom: '20px',
      color: '#333',
      fontSize: '18px',
      fontWeight: '600',
      borderBottom: '1px solid #eee',
      paddingBottom: '8px',
    },
    formGroup: {
      marginBottom: '16px',
    },
    label: {
      display: 'block',
      marginBottom: '6px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#555',
    },
    input: {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxSizing: 'border-box',
      height: '40px',
      '&:focus': {
        borderColor: '#4285f4',
        outline: 'none',
      },
    },
    select: {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxSizing: 'border-box',
      height: '40px',
      backgroundColor: '#fff',
      '&:focus': {
        borderColor: '#4285f4',
        outline: 'none',
      },
    },
    errorText: {
      color: '#d32f2f',
      fontSize: '12px',
      marginTop: '4px',
    },
    warningText: {
      color: '#ff9800',
      fontSize: '12px',
      marginTop: '4px',
    },
    submitButton: {
      padding: '12px 24px',
      backgroundColor: '#4285f4',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '16px',
      fontWeight: '500',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#3367d6',
      },
      '&:disabled': {
        backgroundColor: '#9e9e9e',
        cursor: 'not-allowed',
      },
    },
    moduleCard: {
      padding: '16px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#fafafa',
    },
    removeButton: {
      padding: '8px 16px',
      backgroundColor: '#f44336',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#d32f2f',
      },
    },
    addButton: {
      marginBottom: '16px',
    },
  };



  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await axios.get("batch-summary"); // API endpoint to get batches
        setBatches(response.data);


      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    };

    fetchBatches();
  }, []);


  const fetchintake = async (id) => {
    try {
      console.log("Fetching intake details for batch:", id);
      const response1 = await axios.get(`/intake-details/batch/${id}`); // API endpoint to get batches
      setIntake(response1.data);
      setIntakeOptions(response1.data)

    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };




  const [errors, setErrors] = useState({
    fullname: "",
    fatherName: "",
    brotherName: "",
    // course: "",
    religion: "",
    citizenship: "",
    nric: "",
    brotherPhoneNo: "",
    officephone: "",
    fatherPhoneNo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);

    const lettersOnlyRegex = /^[a-zA-Z\s]*$/;
    const onlyNumberRegex = /^[0-9]*$/;
    let errorMessage = "";

    if (
      ["fullname", "fatherName", "brotherName", "religion", "citizenship"].includes(name) &&
      !lettersOnlyRegex.test(value)
    ) {
      errorMessage = "Only letters are allowed.";
    }

    if (
      ["fatherPhoneNo", "officephone", "brotherPhoneNo"].includes(name) &&
      !onlyNumberRegex.test(value)
    ) {
      errorMessage = "Only numbers are allowed.";
    }

    if (name === "passportExpiryDate" || name === "dob") {
      const year = value.split("-")[0];
      if (year.length > 4) {
        errorMessage = "Year cannot be more than 4 digits.";
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));

    if (errorMessage) return;

    // Handle course select
    if (name === "course") {
      if (!value) {
        // If user selects "Select Course..." (value is ""), reset related fields
        setSelectedBatch(null);
        setStudentData((prevData) => ({
          ...prevData,
          course: "",
          batchId: null,
          startModulus: null,
          enrollmentDate: "",
          scheduleDate: [],
        }));
        return;
      }

      const selectedBatch = batches.find(
        (batch) => batch.course?.trim() === value.trim()
      );

      if (!selectedBatch) {
        console.warn("No matching batch found for course:", value);
        return;
      }

      setSelectedBatch(selectedBatch);
      fetchintake(selectedBatch.id);
      setInitialModulus(selectedBatch.currentModule);

      const moduleCount = selectedBatch.moduleDetails?.length || 0;
      const newScheduleDate = Array.from({ length: moduleCount }, () => ({
        startModulus: '',
        startDate: '',
        endDate: '',
      }));

      setStudentData((prevData) => ({
        ...prevData,
        course: value,
        batchId: selectedBatch.id || null,
        // startModulus: selectedBatch.currentModule || null,
        enrollmentDate: "",
        scheduleDate: newScheduleDate,
      }));
    } else {
      setStudentData({
        ...studentData,
        [name]: value,
      });
    }
  };




  const handleNricEmailChange = async (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setWarnings((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    try {
      if (name === "nric") {
        const response = await axios.get(`/registrationadvances/findExists?nric=${value}`);
        const data = response.data;

        if (data === true) {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else if (data?.status === "Alumni") {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
          setAlumniRegistrationId(data.registrationId);
          setOpenDialog(true);
        } else if (data?.status === "Active") {
          setErrors((prev) => ({
            ...prev,
            [name]: `NRIC already exists with status: ${data.status}. Registration not allowed.`
          }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else if (data?.status === "New") {
          setErrors((prev) => ({ ...prev, [name]: "" })); // Don't block
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC already exists with status "New".`
          }));
        } else if (data?.status === "two-new") {
          setErrors((prev) => ({ ...prev, [name]: "" })); // Still don't block
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC has **two existing New registrations**.`
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        }
      }
      else if (name === "email") {
        const response = await axios.get(`/registrationadvances/exists?email=${value}`);
        const exists = response.data;

        if (exists === true) {
          setErrors((prev) => ({
            ...prev,
            [name]: `EMAIL already exists. Registration not allowed.`
          }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        }
      }
    } catch (error) {
      console.error(`Error checking ${name}:`, error);
      setErrors((prev) => ({
        ...prev,
        [name]: `Error checking ${name}. Try again!`
      }));
      setWarnings((prev) => ({ ...prev, [name]: "" }));
    }
  };










  const handleFileChange = (setFile) => (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!file) return;
    if (!allowedTypes.includes(file.type)) {
      event.target.value = ''; // Reset file input
      toast.error('Only PNG, JPG, or JPEG files are allowed.');
      return;
    }
    if (file.size > 8 * 1024 * 1024) { // 8MB limit
      event.target.value = '';
      toast.error('File size must be less than 8MB.');
      return;
    }
    setFile(file);
  };

  // const uploadFile = async (file, folderPath) => {
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
  //   formData.append('public_id', folderPath);

  //   const response = await fetch(baseURL, {
  //     method: 'POST',
  //     body: formData,
  //   });

  //   const data = await response.json();
  //   if (!data.secure_url) {
  //     throw new Error('Failed to upload file.');
  //   }
  //   return data.secure_url;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();


    // Check if any error messages exist in the errors state
    if (Object.keys(errors).length > 0 && Object.values(errors).some((error) => error.trim() !== "")) {
      toast.error("Please resolve all validation errors before submitting.");
      return;
    }

    const highestCount = studentData.institutionDetails.filter((inst) => inst.highest).length;
    if (highestCount !== 1) {
      toast.error("Please select exactly one education entry as 'Highest'.");
      return;
    }
    
    if (allowAlumniRegistration === false) {
      toast.error("Alumni registration is not allowed for this NRIC.");

      return; // silently block submission
    }

    try {
      setIsUploading(true); // Set uploading state to true
      let profileUrl = "";
      let nricdoc = "";
      let passportdoc = "";
      let educationdoc = "";
      const currentDate = new Date().toISOString().split('T')[0];
      const enrollmentDate = currentDate;
      const offerDate = currentDate;


      // Upload the files
      const uploadFile = async (file) => {
        if (file) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
          formData.append("public_id", `LMS/${file.name} +' - '+ ${timestamp}`);

          const response = await fetch(baseURL, {
            method: "POST",
            body: formData,
          });

          const data = await response.json();
          if (data.secure_url) {
            return data.secure_url;
          } else {
            throw new Error("Failed to upload file.");
          }
        }
        return "";
      };

      profileUrl = await uploadFile(profileFile);
      nricdoc = await uploadFile(nricFile);
      passportdoc = await uploadFile(passportFile);
      educationdoc = await uploadFile(educationFile);

      // Update student data with the uploaded URLs
      const updatedStudentData = {
        ...studentData,
        password: studentData?.nric,
        profileUrl,
        nricdoc,
        passportdoc,
        educationdoc,
        offerDate,
        enrollmentDate,
        startModulus: studentData?.scheduleDate?.[0]?.startModulus || studentData.startModulus,


      };


      // Submit the student data
      const studentResponse = await axios.post("registrationadvances", updatedStudentData);
      console.log("Student data submitted successfully:", studentResponse.data);

      toast.success("Student added successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error submitting student data:", error);
      toast.error("Failed to submit student data. Please try again.");
    } finally {
      setIsUploading(false); // Set uploading state to false after the process
    }
  };


  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;

    const updatedInstitutions = studentData.institutionDetails.map((institution, i) => {
      if (i === index) {
        const updatedInstitution = { ...institution, [name]: value };

        const fromYear = name === 'fromYear' ? value : updatedInstitution.fromYear;
        const toYear = name === 'toYear' ? value : updatedInstitution.toYear;

        // Only validate if both fields are filled with 4-digit years
        if (
          fromYear?.length === 4 &&
          toYear?.length === 4 &&
          !isNaN(Number(fromYear)) &&
          !isNaN(Number(toYear)) &&
          Number(toYear) < Number(fromYear)
        ) {
          toast.error('To Year must be greater than or equal to From Year');
        }

        return updatedInstitution;
      }
      return institution;
    });

    setStudentData({ ...studentData, institutionDetails: updatedInstitutions });
  };





  const handleAddEducation = () => {
    setStudentData({
      ...studentData,
      institutionDetails: [
        ...studentData.institutionDetails,
        { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', highest: false, language: '' },
      ],
    });
  };

  const handleRemoveEducation = (index) => {
    const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
    setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
  };

  const handleEmergencyChange = (index, field, value) => {
    const updatedContacts = [...studentData.emergencyContacts];
    updatedContacts[index][field] = value;
    setStudentData({ ...studentData, emergencyContacts: updatedContacts });
  };

  const handleAddEmergency = () => {
    setStudentData({
      ...studentData,
      emergencyContacts: [
        ...studentData.emergencyContacts,
        { name: '', number: '', relationship: '', othersRelationship: '', natureOfPosition: '' },
      ],
    });
  };

  const handleRemoveEmergency = (index) => {
    const updatedContacts = [...studentData.emergencyContacts];
    updatedContacts.splice(index, 1);
    setStudentData({ ...studentData, emergencyContacts: updatedContacts });
  };



  const handleWorkExperienceChange = (index, e) => {
    const { name, value } = e.target;

    // Clone and update the current experience
    const updatedExperiences = [...studentData.workExpirences];
    const current = updatedExperiences[index];
    const updatedField = { ...current, [name]: value };
    updatedExperiences[index] = updatedField;

    // Parse years
    const fromYear = parseInt(updatedField.fromYear);
    const toYear = parseInt(updatedField.toYear);

    // Set the updated values first
    setStudentData({
      ...studentData,
      workExpirences: updatedExperiences,
    });

    // Only show toast if both fields are completed and invalid
    if (
      name === "fromYear" || name === "toYear" // Only validate when either year changes
    ) {
      if (
        updatedField.fromYear?.length === 4 &&
        updatedField.toYear?.length === 4 &&
        !isNaN(fromYear) &&
        !isNaN(toYear) &&
        toYear < fromYear
      ) {
        toast.error("To Year must be ≥ From Year");
      }
    }
  };



  const handleAddWorkExperience = () => {
    setStudentData((prevState) => ({
      ...prevState,
      workExpirences: [
        ...prevState.workExpirences,
        { name: '', position: '', fromYear: '', toYear: '', country: '', natureOfPosition: '' }
      ]
    }));
    setShowEmploymentFields(true); // Show employment fields after adding
  };

  const handleRemoveWorkExperience = (index) => {
    const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
    setStudentData({
      ...studentData,
      workExpirences: newWorkExperiences
    });
    if (newWorkExperiences.length === 0) {
      setShowEmploymentFields(false); // Hide employment fields if no experience entries
    }
  };
  const dayMapping = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  };

  // const handleDateChange = (event) => {
  //   // Get the new date from the event
  //   const { value } = event.target;
  //   console.log("Selected Enrollment Date:", value);
  //   console.log("Selected Date:", selectedBatch);

  //   const newDate = dayjs(value);
  //   const currentDate = dayjs();

  //   const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
  //   const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

  //   if (selectedBatch?.status && newDate.isBefore(currentDate, 'day') && intakeStartDate) {
  //     toast.error("Enrollment date cannot be before today.");
  //     return;
  //   } else if (selectedBatch?.status && isDatePassed) {
  //     toast.error("Batch is not started yet.");
  //     return;
  //   } else if (selectedBatch?.status && !isDatePassed) {
  //     // If batch status is true, use current module and skip calculations
  //     setStudentData((prevStudentData) => ({
  //       ...prevStudentData,
  //       enrollmentDate: value,
  //       startModulus: selectedBatch?.currentModule,
  //     }));

  //     console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
  //     return; // Exit function
  //   }

  //   // const newDate = dayjs(value); // Create dayjs object from the new date
  //   const oldDate = dayjs();

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));

  //   // Calculate the difference in months between the old and new dates
  //   let monthDifference = newDate.month() - oldDate.month();
  //   if (newDate.year() !== oldDate.year()) {
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }
  //   console.log("Month Difference:", monthDifference);

  //   // For advance diploma, the increment is simply the month difference
  //   let increment = monthDifference;
  //   console.log("Advance Diploma Course - Increment:", increment);

  //   // Calculate the new modulus value based on the increment
  //   let newModulus = initialModulus + increment;
  //   // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
  //   newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
  //   console.log("New Modulus Before Ensuring Range:", newModulus);

  //   const firstDay = selectedBatch.days[0]; // Assuming days is in the correct scope
  //   console.log("First Day from Data:", firstDay.day);

  //   const dayIndex = dayMapping[firstDay.day];
  //   // Determine the first occurrence of the specified day of the month
  //   const firstOfMonth = newDate.date(1); // Set to the first of the month
  //   let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

  //   // If the first occurrence is in the previous month, move to the next week
  //   if (firstSpecifiedDay.isBefore(firstOfMonth)) {
  //     firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
  //   }

  //   console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

  //   // Adjust modulus: if the enrollment date is after the first specified day,
  //   // add 1 to the new modulus.
  //   if (newDate.isAfter(firstSpecifiedDay)) {
  //     newModulus += 1;
  //     console.log("Adjusting Modulus by adding 1.");
  //   }

  //   // Ensure modulus value stays within the 1-12 range after adjustments
  //   newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;

  //   // Update the form data with the new values
  //   setStudentData((prevStudentData) => ({
  //     ...prevStudentData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   }));

  //   console.log("Updated Form Data:", {
  //     startModulus: newModulus,
  //   });
  // };

  const deleteAlumniRegistration = async () => {
    if (!alumniRegistrationId) return;

    try {
      await axios.delete(`/registrationadvances/${alumniRegistrationId}`);
    } catch (err) {
      console.error("Failed to delete alumni registration:", err);
    } finally {
      setOpenDialog(false);
      setAlumniRegistrationId(null);
    }
  };



  const handleManualScheduleStart = (firstModulus, firstDate) => {
    if (!firstDate) {
      toast.warning("Please select Start Date first.");
      return;
    }

    const totalModules = selectedBatch?.moduleDetails?.length || 0;
    const moduli = getCycledModuli(parseInt(firstModulus));
    let startDate = firstDate;
    const modules = [];

    for (let i = 0; i < totalModules; i++) {
      const { endDate, nextStartDate } = getNextWeekDates(startDate);
      modules.push({
        startModulus: moduli[i],
        startDate,
        endDate,
      });
      startDate = nextStartDate;
    }

    setStudentData((prevData) => ({
      ...prevData,
      scheduleDate: modules,
    }));

    console.log("Updated scheduleDate:", modules);
  };



  // Cycle modulus
  const getCycledModuli = (start, count = moduleCount) =>
    Array.from({ length: count }, (_, i) => ((start + i - 1) % moduleCount) + 1);

  // Get next date on same weekday
  const getNextWeekDates = (startDateStr) => {
    const start = new Date(startDateStr);
    const weekCount = selectedBatch?.weekPerModule || 4; // fallback to 4 if not provided

    const endDate = new Date(start);
    endDate.setDate(start.getDate() + (weekCount - 1) * 7);

    const nextStartDate = new Date(endDate);
    nextStartDate.setDate(endDate.getDate() + 7);

    return {
      endDate: endDate.toISOString().split('T')[0],
      nextStartDate: nextStartDate.toISOString().split('T')[0],
    };
  };



  const handleIntakeChange = (e) => {
    const selectedIntakeId = e.target.value;
    console.log("selectedIntakeId:", selectedIntakeId)
    // Always set intakeId state
    setIntakeIdsss(selectedIntakeId);


    // Handle default option ("-- Select Intake --")
    if (selectedIntakeId === "") {
      setStudentData((prevData) => ({
        ...prevData,
        scheduleDate: [],

      }));
      return;
    }

    // Find the selected intake from the options
    const selectedIntake = intakeOptions.find(
      (intake) => String(intake.intakeId) === selectedIntakeId
    );

    if (selectedIntake) {
      const scheduleData = selectedIntake.scheduleDateDetails.map((schedule) => ({
        startModulus: schedule.startModulus,
        startDate: schedule.startDate,
        endDate: schedule.endDate,
      }));

      setStudentData((prevData) => ({
        ...prevData,
        scheduleDate: scheduleData,
        preIntake: selectedIntakeId,


      }));
      console.log("vvvv", selectedIntakeId)
      console.log("Selected Intake:", scheduleData);
    }
  };

  const handleProjectChange = (field, value) => {
    setStudentData((prev) => ({
      ...prev,
      projectSchedule: {
        ...prev.projectSchedule,
        [field]: value,
      },
    }));
  };


  const handleModuleChange = (index, field, value) => {
    const updatedModules = [...studentData.scheduleDate];
    updatedModules[index][field] = field === 'startModulus' ? parseInt(value) : value;
    setStudentData({ ...studentData, scheduleDate: updatedModules });
  };


  return (

    <div className="containerw mx-auto " style={{ maxWidth: '950px', background: '#ffffff', padding: '20px', boxShadow: '0px 0px 2px 0px #000000', borderRadius: '10px', marginTop: '1%' }}>





      <h4 >New Student (Trent International Institute)</h4>
      <hr style={{ marginTop: '1%' }} />



      <form onSubmit={handleSubmit} style={styles.formContainer}>
        <div style={styles.columnsContainer}>
          {/* Left Column */}
          <div style={styles.column}>
            {/* Personal Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Personal Information</h3>

              <div style={styles.formGroup}>
                <label htmlFor="name" style={styles.label}>Name*</label>
                <input
                  type="text"
                  style={styles.input}
                  id="name"
                  name="name"
                  value={studentData.name}
                  onChange={handleChange}
                  required
                />
                {errors.fullname && <p style={styles.errorText}>{errors.fullname}</p>}
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="nric" style={styles.label}>NRIC/FIN No*</label>
                <input
                  type="text"
                  style={styles.input}
                  id="nric"
                  name="nric"
                  value={studentData.nric || ""}
                  onChange={handleNricEmailChange}
                  required
                  maxLength={10}
                />
                {errors.nric && <p style={styles.errorText}>{errors.nric}</p>}
                {warnings.nric && !errors.nric && (
                  <p style={styles.warningText}>{warnings.nric}</p>
                )}
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="email" style={styles.label}>Email*</label>
                <input
                  type="email"
                  style={styles.input}
                  id="email"
                  name="email"
                  value={studentData.email}
                  onChange={handleNricEmailChange}
                  required
                  maxLength={100}
                />
                {errors.email && <p style={styles.errorText}>{errors.email}</p>}
              </div>

              {/* <div style={styles.formGroup}>
                <label htmlFor="password" style={styles.label}>Password*</label>
                <input
                  type="password"
                  id="password"
                  style={styles.input}
                  name="password"
                  value={studentData.password}
                  onChange={handleChange}
                  required
                />
              </div> */}

              <Grid container spacing={2}>
                {/* Gender */}
                <Grid item xs={12} md={6}>
                  <div style={styles.formGroup}>
                    <label htmlFor="gender" style={styles.label}>Gender*</label>
                    <select
                      id="gender"
                      name="gender"
                      style={styles.select}
                      value={studentData.gender}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      {genderOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                </Grid>

                {/* Marital Status */}
                <Grid item xs={12} md={6}>
                  <div style={styles.formGroup}>
                    <label htmlFor="maritalStatus" style={styles.label}>Marital Status*</label>
                    <select
                      id="maritalStatus"
                      name="maritalStatus"
                      style={styles.select}
                      value={studentData.maritalStatus}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Status</option>
                      {statusOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                </Grid>
              </Grid>

              <div style={styles.formGroup} >
                <label htmlFor="dob" style={styles.label}>Date of Birth*</label>
                <input
                  type="date"
                  id="dob"
                  style={styles.input}
                  name="dob"
                  value={studentData.dob}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Contact Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Contact Information</h3>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                <div style={{ flex: 1 }}>
                  <label htmlFor="religion" style={styles.label}>Religion*</label>
                  <input
                    type="text"
                    id="religion"
                    style={styles.input}
                    name="religion"
                    value={studentData.religion}
                    onChange={handleChange}
                    required
                  />
                  {errors.religion && <p style={styles.errorText}>{errors.religion}</p>}
                </div>

                <div style={{ flex: 1 }}>
                  <label htmlFor="citizenship" style={styles.label}>Citizenship*</label>
                  <input
                    type="text"
                    id="citizenship"
                    style={styles.input}
                    name="citizenship"
                    value={studentData.citizenship}
                    onChange={handleChange}
                    required
                  />
                  {errors.citizenship && <p style={styles.errorText}>{errors.citizenship}</p>}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                <div style={{ flex: 1 }}>
                  <label htmlFor="phone" style={styles.label}>Hand Phone*</label>
                  <input
                    type="tel"
                    id="phone"
                    style={styles.input}
                    name="phone"
                    value={studentData.phone}
                    onChange={handleChange}
                    required
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    }}
                  />
                  {errors.phone && <p style={styles.errorText}>{errors.phone}</p>}
                </div>

                <div style={{ flex: 1 }}>
                  <label htmlFor="officephone" style={styles.label}>Office Phone</label>
                  <input
                    type="tel"
                    id="officephone"
                    style={styles.input}
                    name="officephone"
                    value={studentData.officephone}
                    onChange={handleChange}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    }}
                  />
                  {errors.officephone && <p style={styles.errorText}>{errors.officephone}</p>}
                </div>
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="postalcode" style={styles.label}>Postal Code*</label>
                <input
                  type="text"
                  id="postalcode"
                  style={styles.input}
                  name="postalcode"
                  value={studentData.postalcode}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,6}$/.test(input)) {
                      handleChange(e);
                    }
                  }}
                  required
                  maxLength={6}
                />
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="address" style={styles.label}>Home Address*</label>
                <input
                  type="text"
                  id="address"
                  style={styles.input}
                  name="address"
                  value={studentData.address}
                  onChange={handleChange}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="currentAddress" style={styles.label}>Singapore Address</label>
                <input
                  type="text"
                  id="currentAddress"
                  style={styles.input}
                  name="currentAddress"
                  value={studentData.currentAddress}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Education Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Education</h3>

              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <Button
                  type="button"
                  variant="contained"
                  fullWidth
                  onClick={handleAddEducation}
                  style={styles.addButton}
                >
                  + Add Education
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  fullWidth
                  onClick={handleAddWorkExperience}
                  style={styles.addButton}
                >
                  + Add Employment
                </Button>
              </Stack>

              {studentData.institutionDetails.map((institution, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    gap: '16px',
                    marginBottom: '16px',
                    alignItems: 'flex-end',
                    flexWrap: 'wrap',
                    border: '1px solid #ddd',
                    padding: '16px',
                    borderRadius: '8px',
                  }}
                >
                  <div style={{ flex: '1 1 200px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <label style={styles.label}>Institution*</label>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                          type="checkbox"
                          id={`highest-${index}`}
                          checked={institution.highest || false}
                          onChange={(e) => {
                            const updatedInstitutions = studentData.institutionDetails.map((inst, i) => ({
                              ...inst,
                              highest: i === index ? e.target.checked : false,
                            }));
                            setStudentData({ ...studentData, institutionDetails: updatedInstitutions });
                          }}
                          style={{ marginRight: '4px' }}
                        />
                        <label htmlFor={`highest-${index}`} style={{ fontSize: '12px' }}>
                          Highest
                        </label>
                      </div>
                    </div>
                    <input
                      type="text"
                      name="institution"
                      style={styles.input}
                      value={institution.institution}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </div>

                  <div style={{ flex: '1 1 200px' }}>
                    <label style={styles.label}>Degree*</label>
                    <input
                      type="text"
                      name="qualificationsAchieved"
                      style={styles.input}
                      value={institution.qualificationsAchieved}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </div>

                  {/* From Year and To Year - side by side */}
                  <div style={{ display: 'flex', flex: '1 1 250px', gap: '16px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>From Year*</label>
                      <input
                        type="number"
                        name="fromYear"
                        style={styles.input}
                        value={institution.fromYear}
                        onChange={(e) => handleInstitutionChange(index, e)}
                        required
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>To Year*</label>
                      <input
                        type="number"
                        name="toYear"
                        style={styles.input}
                        value={institution.toYear}
                        onChange={(e) => handleInstitutionChange(index, e)}
                        required
                      />
                    </div>
                  </div>

                  <div style={{ flex: '1 1 150px' }}>
                    <label style={styles.label}>Language of Instruction*</label>
                    <input
                      type="text"
                      name="language"
                      style={styles.input}
                      value={institution.language}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </div>

                  <div style={{ flex: '1 1 150px' }}>
                    <label style={styles.label}>Country*</label>
                    <input
                      type="text"
                      name="country"
                      style={styles.input}
                      value={institution.country}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </div>

                  <div style={{ flex: '0 0 auto', marginBottom: '8px' }}>
                    <button
                      type="button"
                      onClick={() => handleRemoveEducation(index)}
                      style={styles.removeButton}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}

            </div>
          </div>

          {/* Right Column */}
          <div style={styles.column}>
            {/* File Upload Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Upload Documents</h3>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="profileFile" style={styles.label}>Upload Photo</label>
                  <input
                    type="file"
                    id="profileFile"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleFileChange(setProfileFile)}
                    style={{ width: '100%' }}
                  />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="nricFile" style={styles.label}>NRIC Document</label>
                  <input
                    type="file"
                    id="nricFile"
                    onChange={handleFileChange(setNricFile)}
                    style={{ width: '100%' }}
                  />
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="educationFile" style={styles.label}>Education Document</label>
                  <input
                    type="file"
                    id="educationFile"
                    onChange={handleFileChange(setEducationFile)}
                    style={{ width: '100%' }}
                  />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="passportFile" style={styles.label}>Passport Document</label>
                  <input
                    type="file"
                    id="passportFile"
                    onChange={handleFileChange(setPassportFile)}
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
            </div>

            {/* Document Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Document Information</h3>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="passport" style={styles.label}>Passport Number*</label>
                  <input
                    type="text"
                    id="passport"
                    style={styles.input}
                    name="passport"
                    value={studentData.passport}
                    onChange={handleChange}
                    maxLength={20}
                    required
                  />
                </div>

                <div style={{ flex: '1 1 200px' }}>
                  <label htmlFor="passportExpiryDate" style={styles.label}>Passport Expiry Date*</label>
                  <input
                    type="date"
                    style={styles.input}
                    id="passportExpiryDate"
                    name="passportExpiryDate"
                    value={studentData.passportExpiryDate}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>

            {/* Emergency Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Emergency Contacts</h3>

              {studentData.emergencyContacts.map((contact, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: '20px',
                    border: '1px solid #ddd',
                    padding: '16px',
                    borderRadius: '8px',
                  }}
                >
                  <div style={{ marginBottom: '12px' }}>
                    <label style={styles.label}>Relationship</label>
                    <select
                      style={styles.select}
                      value={contact.relationship}
                      onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)}
                      required
                    >
                      <option value="">-- Select Relationship --</option>
                      <option value="Father">Father</option>
                      <option value="Mother">Mother</option>
                      <option value="Brother">Brother</option>
                      <option value="Sister">Sister</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>

                  {contact.relationship === 'Others' && (
                    <div style={{ marginBottom: '12px' }}>
                      <label style={styles.label}>Relationship with Applicant</label>
                      <input
                        type="text"
                        style={styles.input}
                        placeholder="Enter relationship"
                        value={contact.othersRelationship}
                        onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)}
                        required
                      />
                    </div>
                  )}

                  <div style={{ display: 'flex', gap: '16px', marginBottom: '12px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Name</label>
                      <input
                        type="text"
                        style={styles.input}
                        value={contact.name}
                        onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)}
                        required
                      />
                    </div>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Contact No</label>
                      <input
                        type="tel"
                        maxLength={10}
                        style={styles.input}
                        value={contact.number}
                        onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div style={{ textAlign: 'right' }}>
                    <button
                      type="button"
                      onClick={() => handleRemoveEmergency(index)}
                      style={styles.removeButton}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}

              <Button
                type="button"
                onClick={handleAddEmergency}
                variant="contained"
                fullWidth
              >
                + ADD EMERGENCY
              </Button>
            </div>

            {/* Course Information Section */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Course Information</h3>

              <div style={styles.formGroup}>
                <label htmlFor="course" style={styles.label}>Course*</label>
                <select
                  id="course"
                  style={styles.select}
                  name="course"
                  value={studentData.course}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Course...</option>
                  {batches.map((batch) => (
                    <option key={batch.id} value={batch.course}>
                      {batch.course}
                    </option>
                  ))}
                </select>
              </div>

              <div style={styles.formGroup}>
                <label htmlFor="intakeId" style={styles.label}>Select Intake</label>
                <select
                  id="intakeId"
                  name="intakeId"
                  style={styles.select}
                  value={intakeIdsss}
                  onChange={handleIntakeChange}
                >
                  <option value="">-- Select Intake --</option>
                  {intakeOptions.map((intake) => (
                    <option key={intake.id} value={intake.intakeId}>
                      {intake.intakeId}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Employment Section */}
            {showEmploymentFields && (
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Employment History</h3>

                {studentData.workExpirences.map((experience, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      gap: '16px',
                      marginBottom: '16px',
                      padding: '16px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      alignItems: 'flex-end',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Name*</label>
                      <input
                        type="text"
                        name="name"
                        style={styles.input}
                        value={experience.name}
                        onChange={(e) => handleWorkExperienceChange(index, e)}
                        required
                      />
                    </div>

                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Position*</label>
                      <input
                        type="text"
                        name="position"
                        style={styles.input}
                        value={experience.position}
                        onChange={(e) => handleWorkExperienceChange(index, e)}
                        required
                      />
                    </div>

                    <div style={{ flex: '1 1 150px' }}>
                      <label style={styles.label}>Country*</label>
                      <input
                        type="text"
                        name="country"
                        style={styles.input}
                        value={experience.country}
                        onChange={(e) => handleWorkExperienceChange(index, e)}
                        required
                      />
                    </div>

                    <div style={{ flex: '1 1 150px' }}>
                      <label style={styles.label}>Nature of Duties*</label>
                      <input
                        type="text"
                        name="natureOfPosition"
                        style={styles.input}
                        value={experience.natureOfPosition}
                        onChange={(e) => handleWorkExperienceChange(index, e)}
                        required
                      />
                    </div>

                    {/* From and To year side by side */}
                    <div style={{ display: 'flex', flex: '1 1 250px', gap: '16px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={styles.label}>From*</label>
                        <input
                          type="number"
                          name="fromYear"
                          style={styles.input}
                          value={experience.fromYear}
                          onChange={(e) => handleWorkExperienceChange(index, e)}
                          required
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={styles.label}>To*</label>
                        <input
                          type="number"
                          name="toYear"
                          style={styles.input}
                          value={experience.toYear}
                          onChange={(e) => handleWorkExperienceChange(index, e)}
                          required
                        />
                      </div>
                    </div>

                    <div style={{ flex: '0 0 auto', marginBottom: '8px' }}>
                      <button
                        type="button"
                        onClick={() => handleRemoveWorkExperience(index)}
                        style={styles.removeButton}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>

        {/* Module Schedule Section */}
        {studentData.scheduleDate.length > 0 && (
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Module Schedule</h3>

            {studentData.scheduleDate.length > 0 && (
              <div style={{ marginBottom: '20px' }}>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 200px' }}>
                    <label style={styles.label}>Start Date</label>
                    <input
                      type="date"
                      value={studentData.scheduleDate[0]?.startDate || ''}
                      onChange={(e) =>
                        handleManualScheduleStart(
                          studentData.scheduleDate[0]?.startModulus || '',
                          e.target.value
                        )
                      }
                      style={styles.input}
                    />
                  </div>

                  <div style={{ flex: '1 1 200px' }}>
                    <label style={styles.label}>Start Module</label>
                    <select
                      value={studentData.scheduleDate[0]?.startModulus || ''}
                      onChange={(e) =>
                        handleManualScheduleStart(e.target.value, studentData.scheduleDate[0]?.startDate || '')
                      }
                      style={styles.select}
                    >
                      <option value="">Select Module</option>
                      {selectedBatch?.moduleDetails?.map((module) => (
                        <option key={module.id} value={module.id}>
                          {module?.moduleName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: '16px'
            }}>
              {studentData.scheduleDate.map((module, index) => (
                <div key={index} style={styles.moduleCard}>
                  <h6 style={{ marginBottom: '12px', fontWeight: '600' }}>
                    Module {index + 1}
                  </h6>

                  <div style={styles.formGroup}>
                    <label htmlFor={`startModulus-${index}`} style={styles.label}>Start Module</label>
                    <input
                      id={`startModulus-${index}`}
                      style={styles.input}
                      value={
                        selectedBatch?.moduleDetails?.find(
                          (m) => m.id === module.startModulus
                        )?.moduleName || module.startModulus
                      }
                      readOnly
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor={`startDate-${index}`} style={styles.label}>Start Date</label>
                    <input
                      type="date"
                      id={`startDate-${index}`}
                      style={styles.input}
                      value={module.startDate}
                      onChange={(e) =>
                        handleModuleChange(index, "startDate", e.target.value)
                      }
                      required
                    />
                  </div>

                  <div style={styles.formGroup}>
                    <label htmlFor={`endDate-${index}`} style={styles.label}>End Date</label>
                    <input
                      type="date"
                      id={`endDate-${index}`}
                      style={styles.input}
                      value={module.endDate}
                      onChange={(e) =>
                        handleModuleChange(index, "endDate", e.target.value)
                      }
                      required
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Project Details */}
        <div style={styles.columnsContainer}>
          {selectedBatch?.project === true && (
            <div style={styles.column}>
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Project Details</h3>

                <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 300px' }}>
                    <label htmlFor="projectCode" style={styles.label}>Project Code*</label>
                    <input
                      type="text"
                      id="projectCode"
                      style={styles.input}
                      name="projectCode"
                      value={studentData.projectSchedule?.projectCode || ''}
                      onChange={(e) => handleProjectChange('projectCode', e.target.value)}
                      required
                    />
                  </div>

                  <div style={{ flex: '1 1 150px' }}>
                    <label htmlFor="projectstartDate" style={styles.label}>Start Date*</label>
                    <input
                      type="date"
                      id="projectstartDate"
                      style={styles.input}
                      name="projectstartDate"
                      value={studentData.projectSchedule?.startDate || ''}
                      onChange={(e) => handleProjectChange('startDate', e.target.value)}
                      required
                    />
                  </div>

                  <div style={{ flex: '1 1 150px' }}>
                    <label htmlFor="projectendDate" style={styles.label}>End Date*</label>
                    <input
                      type="date"
                      id="projectendDate"
                      style={styles.input}
                      name="projectendDate"
                      value={studentData.projectSchedule?.endDate || ''}
                      onChange={(e) => handleProjectChange('endDate', e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          )}


          {/* Commencement and Completion Section */}
          <div style={styles.column}>
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Commencement & Complete</h3>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
                <div style={{ flex: '1 1 100px' }}>
                  <label htmlFor="commencementDate" style={styles.label}>Commencement Date*</label>
                  <input
                    type="date"
                    id="commencementDate"
                    style={styles.input}
                    name="commencementDate"
                    value={studentData.commencementDate}
                    onChange={handleChange}
                    required
                  />
                </div>


                {/* Complete Date */}
                <div style={{ flex: '1 1 100px' }}>
                  <label htmlFor="completeDate" style={styles.label}>Complete Date*</label>
                  <input
                    type="date"
                    style={styles.input}
                    id="completeDate"
                    name="completeDate"
                    value={studentData.completeDate}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Sign Date */}
              <div style={{ flex: '1 1 200px' }}>
                <label htmlFor="signDate" style={styles.label}>Sign Date*</label>
                <input
                  type="date"
                  id="signDate"
                  style={styles.input}
                  name="signDate"
                  value={studentData.signDate}
                  onChange={handleChange}
                  required
                />
              </div>



            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <button
            type="submit"
             style={{
              padding: "12px 24px",
              backgroundColor: isUploading ? "#9e9e9e" : "#4285f4", 
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: isUploading ? "not-allowed" : "pointer", 
            }}
            disabled={isUploading}
          >
            {isUploading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>


      <ToastContainer />


      <Dialog open={openDialog} onClose={() => {
        setOpenDialog(false);
        setAllowAlumniRegistration(false); // cancel = block form
      }}>
        <DialogTitle>Re-register Alumni?</DialogTitle>
        <DialogContent>
          This NRIC belongs to an alumni student. Are you sure you want to re-register?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
              setAllowAlumniRegistration(false); // explicitly disallow
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await deleteAlumniRegistration();
              setAllowAlumniRegistration(true); // allow form submission
            }}
            color="primary"
          >
            Yes, Register
          </Button>
        </DialogActions>
      </Dialog>



    </div >
  );
};


const NewStudenth = ({ onFormSubmit }) => {
  return (
    <div>

      {/* <NavigationButtons /> */}
      <NewStudent onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default NewStudenth;
